import 'svgxuse';
import 'intersection-observer';
import MmenuLight from 'mmenu-light';
import 'mmenu-light/dist/mmenu-light.polyfills';

import "core-js/modules/es.array.iterator";
import "core-js/modules/es.promise";

const axios = require('axios');
let tracking = require('./tracking');

let internals = {
    menu_opened: false,
    init: function () {
        let hamburger = document.getElementById("menu_open");

        if (hamburger == null) return;

        const menu = new MmenuLight(
            document.querySelector("#menu__wrap"),
            "(max-width: 1179px)"
        );

        const navigator = menu.navigation({
            title: 'YL Raisa'
        });
        const drawer = menu.offcanvas({
            position: 'right'
        });

        hamburger.addEventListener('click', (evnt) => {
            evnt.preventDefault();
            if (internals.menu_opened) {
                drawer.close();
            } else {
                drawer.open();
            }
            hamburger.classList.toggle("is-active");
            internals.menu_opened = !internals.menu_opened;
        });

        document.querySelector('.mm-ocd__backdrop').addEventListener('click', function () {
           hamburger.classList.remove("is-active");
           internals.menu_opened = false;
        });

        internals.initLazyImages();
        internals.initModals();
        internals.initGlobals();
        internals.initFooterMenu();
        //internals.initSearch();
        internals.initForms();
        tracking.init();
        internals.observeHorns();
        internals.initScroll();
    },
    initGlobals: function () {
        // Setup sentry
        window.sentry_options = {
            dsn: document.querySelector('body').getAttribute('data-sentry-dsn'),
            release: document.querySelector('body').getAttribute('data-sentry-release'),
            environment: document.querySelector('body').getAttribute('data-sentry-environment')
        };


        let USER_ID = document.querySelector('body').getAttribute('data-user-id');

        if (USER_ID) {
            window.sentry_user_context = {
                email: document.querySelector('body').getAttribute('data-user-email'),
                id: USER_ID
            };
        } else {
            window.sentry_user_context = null;
        }

        // Setup global data layer
        window.dataLayer = window.dataLayer || [];

        window.gtag = function () {
            dataLayer.push(arguments);
        };

        // Metrika
        let YM_ID = document.querySelector('body').getAttribute('data-ym-id');

        window.ym = window.ym || function () {
            (window.ym.a = window.ym.a || []).push(arguments)
        };

        ym(YM_ID, "init", {
            clickmap: true,
            trackLinks: true,
            webvisor: document.querySelector('body').getAttribute('data-ym-webvisor'),
            accurateTrackBounce: true,
            ecommerce: "dataLayer",
            trackHash: true
        });

        // FB Pixel
        let FB_PIXEL_ID = document.querySelector('body').getAttribute('data-fb-pixel-id');

        if (FB_PIXEL_ID) {

            var n = window.fbq = function () {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };
            if (!window._fbq) window._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
        }
    },
    initModals: function () {
        let modals = require('./modals.js');
        modals.init();
    },
    initLazyImages: function () {
        let images = require('./image.js');
        images.init();
    },
    initForms: function () {
        document.querySelectorAll('.form--inline input').forEach(function (val, key) {
            val.addEventListener('focus', internals.focusForm);
        });
    },
    focusForm: function (e) {
        let form = e.target.form;

        let initialized = form.getAttribute('data-initialized') === "true";

        if (initialized) return;

        form.querySelector('button[type=submit]').disabled = false;

        import(/* webpackChunkName: "validation" */'./validation').then(function (validation) {
            let fv = validation.fv(
                form,
                {
                    plugins: {
                        declarative: new validation.DeclarativePlugin(),
                        submitButton: new validation.SubmitButtonPlugin(),
                        bootstrap: new validation.BootstrapPlugin({
                            rowSelector: '.form__group'
                        }),
                        trigger: new validation.TriggerPlugin(),
                        recaptcha: new validation.RecaptchaPlugin({
                            element: form.getAttribute('data-fvp-recaptcha___element'),
                            language: form.getAttribute('data-fvp-recaptcha___language'),
                            message: form.getAttribute('data-fvp-recaptcha___message'),
                            siteKey: form.getAttribute('data-fvp-recaptcha___site-key'),
                            theme: form.getAttribute('data-fvp-recaptcha___theme'),
                            size: form.getAttribute('data-fvp-recaptcha___size'),
                            badge: form.getAttribute('data-fvp-recaptcha___badge')
                        }),
                    }
                }
            ).on('core.form.valid', function () {
                internals.submitForm(fv.getFormElement()).then(function (response) {
                    form.innerHTML = response.message;

                    if (form.getAttribute('data-goal')) {
                        let tracking = require('./tracking');
                        tracking.reachGoal(form.getAttribute('data-goal'));
                    }

                    if (form.getAttribute('data-ga-goal')) {
                        gtag('event', form.getAttribute('data-ga-goal'), {
                            eventAction: 'click'
                        });
                    }
                });
            });

            validation.initIntlTelInput();

            form.setAttribute('data-initialized', true);
        });
    },
    initScroll: function() {
        let backBtn = document.getElementById('back');

        //Стиль шапки при скролле
        window.addEventListener('scroll', function () {
            let height = window.pageYOffset;
            if (height > 200) {
                backBtn.classList.add('visible');
            } else {
                backBtn.classList.remove('visible');
            }
        });

        // On load
        let height = window.pageYOffset;

        if (height > 200) {
            backBtn.classList.add('visible');
        } else {
            backBtn.classList.remove('visible');
        }

        document.getElementById("back").addEventListener('click', function (e) {
            e.preventDefault();
            window.scrollTo(window.pageXOffset, 0);
        });

    },
    serialize: function (form) {
        // Setup our serialized data
        let serialized = [];

        // Loop through each field in the form
        for (let i = 0; i < form.elements.length; i++) {

            let field = form.elements[i];

            // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
            if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

            // If a multi-select, get all selections
            if (field.type === 'select-multiple') {
                for (let n = 0; n < field.options.length; n++) {
                    if (!field.options[n].selected) continue;
                    serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
                }
            }

            // Convert field data to a query string
            else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
            }
        }

        return serialized.join('&');
    },
    submitForm: function (form) {
        let submitButton = form.querySelector('button[type=submit]');

        let disabled = submitButton.getAttribute('disabled');

        if (disabled === 'disabled') {
            return Promise.resolve();
        }

        submitButton.setAttribute('disabled', 'disabled');

        let uri = form.getAttribute('action');

        let elements = [].slice.call(document.querySelectorAll('[data-fv-int-phone-number]'));
        elements.forEach((ele) => {
            let iti = window.intlTelInputGlobals.getInstance(ele);
            ele.value = iti.getNumber(0);
        });

        return axios({
            url: uri,
            method: 'post',
            headers: {
                'Accept': 'application/json'
            },
            data: internals.serialize(form)
        }).then(function (response) {
            return Promise.resolve(response.data);
        }).catch(function (e) {
            submitButton.removeAttribute('disabled');
            if (e.response) {
                if (e.response.status === 422) {
                    internals.renderFormErrors(form, e.response.data);
                    return Promise.reject(new Error("Form submission failed, Data: " + JSON.stringify(e)));
                } else {
                    return Promise.reject(new Error("Form submission failed, Code: " + e.response.status));
                }
            }
            return Promise.reject(new Error("Form submission failed: " + e.message));
        })
    },
    renderFormErrors: function (form, data) {
        let container = form.querySelector('.form-errors');
        container.classList.remove('hidden');
        container.innerHTML = '';

        container.innerHTML += `<div class="alert alert-danger">Form submission error</div>`;

        for (let field in data.errors) {
            container.innerHTML += `<div class="alert alert-danger">${data.errors[field]}</div>`;
        }
    },
    initFooterMenu: function () {
        document.querySelectorAll('.footer-menu__header').forEach(function (val, key) {
            val.addEventListener('click', internals.footerMenuToggle);
        });
    },
    footerMenuToggle: function (e) {
        if (window.innerWidth < 1366) {
            e.preventDefault();

            this.classList.toggle('footer-menu__header--active');
        }
    },
    initSearch: function () {
        let btnSearch = document.getElementById("btn_search");
        let fieldSearch = document.getElementById("field_search");
        btnSearch.addEventListener("click", function () {
            fieldSearch.classList.toggle("nav-search__field--active");
        });
    },
    observeHorns: function () {
        let observer = new IntersectionObserver(function (entries, observer) {
            for (let i = 0; i < entries.length; i++) {
                let entry = entries[i];
                if (entry.isIntersecting) {
                    import(/* webpackChunkName: "anime" */ 'animejs').then(function (module) {
                        module.default({
                            targets: '.footer__social-horn > svg',
                            rotate: {
                                value: '+=7deg',
                                duration: 800,
                                easing: 'easeInOutSine'
                            },
                            direction: 'alternate',
                            delay: module.default.stagger(200),
                            loop: true
                        });
                    });
                    observer.disconnect();
                }
            }
        }, {
            rootMargin: '10px 0px',
            threshold: 0.01
        });
        observer.observe(document.getElementById('footer'));
    },
    observeSlider: function (element, slider) {
        if (!('IntersectionObserver' in window)) {
            slider.init();
        } else {
            let observer = new IntersectionObserver(function (entries, observer) {
                for (let i = 0; i < entries.length; i++) {
                    let entry = entries[i];
                    if (entry.isIntersecting) {
                        slider.init();
                        observer.disconnect();
                    }
                }
            }, {
                rootMargin: '10px 0px',
                threshold: 0.01
            });
            observer.observe(document.getElementById(element));
        }
    }
};

export const init = internals.init;
export const submitForm = internals.submitForm;
export const observeSlider = internals.observeSlider;
